import { render, staticRenderFns } from "./SettingsAddress.vue?vue&type=template&id=002456f5&scoped=true"
import script from "./SettingsAddress.vue?vue&type=script&lang=js"
export * from "./SettingsAddress.vue?vue&type=script&lang=js"
import style0 from "./SettingsAddress.vue?vue&type=style&index=0&id=002456f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002456f5",
  null
  
)

export default component.exports